
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"235","height":"240","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M233.599 125.901c0 62.739-50.86 113.598-113.598 113.598-62.739 0-113.599-50.859-113.599-113.598 0-62.738 50.86-113.598 113.599-113.598 62.738 0 113.598 50.86 113.598 113.598z","stroke":"#CF3E5A"}}),_c('circle',{attrs:{"cx":"114.098","cy":"114.098","fill":"#CF3E5A","r":"114.098"}}),_c('path',{attrs:{"d":"M147.951 80.246l-67.705 67.705M80.246 80.246l67.705 67.705","stroke":"#F9F9F9","stroke-width":"15","stroke-linecap":"round"}})])
          )
        }
      }
    